module.exports = __webpack_public_path__ + "img/矢量智能对象.245d3c53.webp";